import { createAction, props } from '@ngrx/store';
import { SchedulesTypes } from '@mode/shared/contract-common';
import { ApiTypes, PaginationTypes } from '@mode/shared/contract-common';

export const loadSchedules = createAction(
  '[Schedules] Load Schedules',
  props<{ username: string; page: number; query: string; filters: string; sort: string }>()
);

export const loadSchedulesSuccess = createAction(
  '[Schedules] Load Schedules Success',
  props<{ pagination: PaginationTypes.Pagination; schedules: SchedulesTypes.Schedule[] }>()
);

export const loadSchedulesFailure = createAction('[Schedules] Load Schedules Failure', props<{ error: Error }>());

export const deleteSchedule = createAction(
  '[Schedules] Delete Schedule',
  props<{ token: string; deleteForm: ApiTypes.ModeForm }>()
);

export const deleteScheduleSuccess = createAction('[Schedules] Delete Schedule Success', props<{ token: string }>());

export const deleteScheduleFailure = createAction('[Schedules] Delete Schedule Failure', props<{ error: Error }>());

export const openScheduleModal = createAction(
  '[Schedules] Open Schedule Modal',
  props<{ token: string; reportToken: string }>()
);

export const openWorkspaceSettingScheduleModal = createAction(
  '[Schedules] Open Workspace Setting Schedule Modal',
  props<{ token: string; reportToken: string }>()
);

export const bulkDeleteSchedule = createAction(
  '[Schedules] Bulk Delete Schedule',
  props<{ payload: SchedulesTypes.BulkDeleteResource }>()
);

export const bulkDeleteScheduleSuccess = createAction(
  '[Schedules] Delete Schedules Success',
  props<{ payload: SchedulesTypes.BulkDeleteResource }>()
);

export const bulkDeleteScheduleFailure = createAction(
  '[Schedules] Delete Schedules Failure',
  props<{ error: Error }>()
);

export const reloadSchedules = createAction('[Schedules] Reload Schedules');

export const updateSchedulesSort = createAction('[Schedules] Sorting', props<{ sort: string }>());
export const updateSchedulesFilter = createAction('[Schedules] Filters', props<{ filter: string }>());

export const loadScheduleIntervalThreshold = createAction(
  '[Schedule] Load Schedule Interval Threshold',
  props<{ accountID: string }>()
);

export const loadScheduleIntervalThresholdSuccess = createAction(
  '[Schedule] Load Schedule Interval Threshold Success',
  props<{ minimumScheduleInterval: string; availableIntervals: string[] }>()
);

export const loadScheduleIntervalThresholdFailure = createAction(
  '[Schedule] Load Schedule Interval Threshold Failure',
  props<{ error: any }>()
);

export const updateScheduleIntervalThreshold = createAction(
  '[Schedule] Update Schedule Interval Threshold',
  props<{ accountID: string; interval: string }>()
);

export const updateScheduleIntervalThresholdSuccess = createAction(
  '[Schedule] Update Schedule Interval Threshold Success',
  props<{ minimumScheduleInterval: string }>()
);

export const updateScheduleIntervalThresholdFailure = createAction(
  '[Schedule] Update Schedule Interval Threshold Failure',
  props<{ error: any }>()
);
